import React from 'react';
import './App.css';
import Chart from './Chart.js';
import Select from 'react-select';
import Grid from '@material-ui/core/Grid'

export default class ChartWithSelect extends React.Component {
  constructor(props) {
    super(props)
    this.genesByName = props.genesByName

    var firstGene = Object.keys(this.genesByName)[0];
    this.state = { selectedGene : firstGene};
  }

  handleChange = selectedGene => {
    this.setState({ selectedGene : selectedGene['value']}); // selectedGene is an object returned by the Select component. Its schema is specific to that component and is defined outside of the scope of this program. It should look like: {value: "Aacs", label: "Aacs"}.
  };

  render() {
    return (
      <div className="THISNEEDSACLASSNAME">
        <Grid container className="grid">
          <Grid item xs={3}> 
            Select a Gene: 
          </Grid>
          <Grid item xs={3}> 
          <Select className="select" options = {this.props.listOfGenesForSelect} defaultValue = {this.props.listOfGenesForSelect[0]} onChange={this.handleChange}/>
          </Grid>
            <Chart dataForChart={this.genesByName[this.state.selectedGene]} currentGene={this.state.selectedGene} listOfCategories={this.props.listOfCategories}></Chart>
        </Grid>
      </div>
    );
  }
}


